import React, { useEffect, Children } from 'react';
import { motion } from 'framer-motion';
import { ArrowLeft, Shield } from 'lucide-react';
import { Link } from 'react-router-dom';
export function PrivacyPolicy() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Privacy Policy | IntelliEats';
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} className="pt-32 pb-24 bg-white min-h-screen" data-id="element-2839" data-mp="1zzyua5wmrizr">
      
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2840" data-mp="1caw2444de7r0">
        <header className="mb-12" data-id="element-2841" data-mp="189u1pjypvpng">
          <Link to="/" className="inline-flex items-center text-sm font-medium text-brand-600 hover:text-brand-700 mb-8 transition-colors" data-id="element-2842" data-mp="18avpmp0u06ml">
            
            <ArrowLeft className="w-4 h-4 mr-2" data-id="element-2843" data-mp="1h97bkdqr6g8p" />
            Back to Home
          </Link>
          <div className="flex items-center gap-4 mb-6" data-id="element-2844" data-mp="tjv2rezc8a6x">
            <div className="bg-brand-100 text-brand-600 p-3 rounded-2xl" data-id="element-2845" data-mp="tiblbl1y3t3k">
              <Shield className="w-8 h-8" data-id="element-2846" data-mp="oka7pfnaglzh" />
            </div>
            <h1 className="text-4xl sm:text-5xl font-black text-slate-900 tracking-tight" data-id="element-2847" data-mp="30witetvw9nsz">
              Privacy Policy
            </h1>
          </div>
          <p className="text-slate-500 text-sm" data-id="element-2848" data-mp="35trccwov9vva">Last updated: April 7, 2025</p>
        </header>

        <div className="space-y-10 text-slate-700 leading-relaxed" data-id="element-2849" data-mp="3amkjtsbpzib2">
          <section data-id="element-2850" data-mp="3flf1us1v52u4">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2851" data-mp="3fju997z3ztyw">
              1. Introduction
            </h2>
            <p data-id="element-2852" data-mp="2hz7vpdpwv2fn">
              Welcome to IntelliEats ("we," "our," or "us"). We are committed to
              protecting your personal information and your right to privacy.
              This Privacy Policy explains how we collect, use, disclose, and
              safeguard your information when you use our mobile application
              IntelliEats (the "App").
            </p>
          </section>

          <section data-id="element-2853" data-mp="77esrupyyfm4">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2854" data-mp="b6xe2rlpcsph">
              2. Information We Collect
            </h2>
            <div className="space-y-4" data-id="element-2855" data-mp="2871tmnjctiet">
              <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100" data-id="element-2856" data-mp="285qgvy7xl0bk">
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-2857" data-mp="237ozdhq5l927">
                  Camera & Photo Access
                </h3>
                <p className="m-0" data-id="element-2858" data-mp="2h65g81hqcfy2">
                  We access your device camera and photo gallery solely to scan
                  ingredient labels. Images are processed locally on your device
                  for analysis and are not stored
                  permanently.
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100" data-id="element-2859" data-mp="1kg5zhjrfeb4e">
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-2860" data-mp="1ybgq2kyn0a2y">Usage Data</h3>
                <p className="m-0" data-id="element-2861" data-mp="1th44a49oumo1">
                  We may collect anonymous usage data such as app interactions,
                  scan frequency, and feature usage to improve the App's
                  performance and user experience.
                </p>
              </div>
              <div className="bg-slate-50 rounded-2xl p-6 border border-slate-100" data-id="element-2862" data-mp="3cgadigrkmpp3">
                <h3 className="font-bold text-slate-900 mb-2" data-id="element-2863" data-mp="3h8l9x9n3rtcw">
                  Device Information
                </h3>
                <p className="m-0" data-id="element-2864" data-mp="33hydxp8q8hki">
                  We may collect device type, operating system version, and
                  unique device identifiers for analytics and troubleshooting
                  purposes.
                </p>
              </div>
            </div>
          </section>

          <section data-id="element-2865" data-mp="40ibo21t8o4n">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2866" data-mp="4106qvcqkwaz">
              3. How We Use Your Information
            </h2>
            <ul className="space-y-3 list-none p-0" data-id="element-2867" data-mp="3m9iwrzj25bkq">
              <li className="flex items-start gap-3" data-id="element-2868" data-mp="3r4y408mk8986">
                <span className="w-2 h-2 bg-brand-500 rounded-full mt-2 shrink-0" data-id="element-2869" data-mp="2as9br8ka6bhb"></span>
                <span data-id="element-2870" data-mp="2fr2qt5f7uajl">
                  To provide and maintain the ingredient scanning and analysis
                  service
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2871" data-mp="2v20qgqus1yw6">
                <span className="w-2 h-2 bg-brand-500 rounded-full mt-2 shrink-0" data-id="element-2872" data-mp="2q9hchss6h1qu"></span>
                <span data-id="element-2873" data-mp="2m85ua8bmviso">
                  To improve, personalize, and expand our App's features
                </span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2874" data-mp="2ham5iehb7nmh">
                <span className="w-2 h-2 bg-brand-500 rounded-full mt-2 shrink-0" data-id="element-2875" data-mp="3dzboy98l4oak"></span>
                <span data-id="element-2876" data-mp="39y08at7ovdei">To understand and analyze how you use our App</span>
              </li>
              <li className="flex items-start gap-3" data-id="element-2877" data-mp="39w5m7bkolf8u">
                <span className="w-2 h-2 bg-brand-500 rounded-full mt-2 shrink-0" data-id="element-2878" data-mp="34xu8gpr9mklc"></span>
                <span data-id="element-2879" data-mp="300lul1d5h2pw">
                  To communicate with you for customer service and updates
                </span>
              </li>
            </ul>
          </section>

          <section data-id="element-2880" data-mp="1okx2jvl1hdi8">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2881" data-mp="1okdv58t0m7ig">
              4. Data Sharing & Third Parties
            </h2>
            <p data-id="element-2882" data-mp="1ei9voo5naspl">
              We do not sell, trade, or rent your personal information to third
              parties. We may share anonymized, aggregated data with analytics
              partners to improve our services. Any third-party services used
              (such as analytics tools) are bound by their own privacy policies.
            </p>
          </section>

          <section data-id="element-2883" data-mp="1x66j1tqz0q8g">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2884" data-mp="1x6onhdnsearg">
              5. Data Security
            </h2>
            <p data-id="element-2885" data-mp="224giigjqaczv">
              We implement appropriate technical and organizational security
              measures to protect your personal information. However, no method
              of transmission over the Internet or electronic storage is 100%
              secure, and we cannot guarantee absolute security.
            </p>
          </section>

          <section data-id="element-2886" data-mp="hpo8ka46sefa">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2887" data-mp="hr94a328m3eq">
              6. Children's Privacy
            </h2>
            <p data-id="element-2888" data-mp="9q0cp6pwa5j2">
              Our App is rated for ages 4+ and does not knowingly collect
              personal information from children under 13. If you believe we
              have collected information from a child under 13, please contact
              us immediately.
            </p>
          </section>

          <section data-id="element-2889" data-mp="eqxrd9bp4hft">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2890" data-mp="soco6z4a3rht">
              7. Changes to This Policy
            </h2>
            <p data-id="element-2891" data-mp="nqb4cbz13o5a">
              We may update this Privacy Policy from time to time. We will
              notify you of any changes by posting the new Privacy Policy on
              this page and updating the "Last updated" date.
            </p>
          </section>

          <section className="bg-brand-50 rounded-2xl p-8 border border-brand-100" data-id="element-2892" data-mp="1bf3ufrsyz1rz">
            <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-2893" data-mp="1bcrdnhyy6xgi">
              8. Contact Us
            </h2>
            <p className="mb-4" data-id="element-2894" data-mp="1q1t1cepjwh8e">
              If you have any questions about this Privacy Policy, please
              contact us:
            </p>
            <p className="font-medium text-slate-900" data-id="element-2895" data-mp="1uzm93c6i5jas">
              Email:{' '}
              <a href="mailto:intellieats@gmail.com" className="text-brand-600 hover:text-brand-700 transition-colors" data-id="element-2896" data-mp="1h1xl3vh51w1i">
                
                intellieats@gmail.com
              </a>
            </p>
            <p className="mt-2" data-id="element-2897" data-mp="17a9yq8zfv56w">
              Or use our{' '}
              <Link to="/contact" className="text-brand-600 hover:text-brand-700 font-medium transition-colors" data-id="element-2898" data-mp="1c1rqc6fkntf7">
                
                Contact Support
              </Link>{' '}
              page.
            </p>
          </section>
        </div>
      </div>
    </motion.div>;
}